import { render, staticRenderFns } from "./newawardcard.vue?vue&type=template&id=cf6f4034&scoped=true"
import script from "./newawardcard.vue?vue&type=script&lang=js"
export * from "./newawardcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6f4034",
  null
  
)

export default component.exports